import * as utils from '@/utils/main_utils'
import axios from '@/utils/axios_iface'

export default {
  state: {
    selected_country: undefined,
    selected_language: undefined,
    translations: undefined,
    arrow_alignment: 'rightarrow',
    user_location: undefined,
  },

  mutations: {
    SET_LANG_DIRECTION(state, direction) {
      state.arrow_alignment =
        direction === 'rtl' ? 'store-left-arrow' : 'rightarrow'
      document.body.style.direction = direction
      state.arrow_alignment =
        direction === 'rtl' ? 'store-left-arrow' : 'rightarrow'
      document.body.classList.remove('body-ltr')
      document.body.classList.remove('body-rtl')
      document.body.classList.add('body-' + direction)
    },
    SET_SELECTED_COUNTRY: (state, country) => {
      state.selected_country = country
    },
    SET_SELECTED_LANG: (state, lang) => (state.selected_language = lang),
    SET_TRANSLATIONS: (state, translations) =>
      (state.translations = translations),
    SET_USER_LOCATION: (state, location) => {
      state.user_location = location
    },
  },
  actions: {
    setupTranslations: ({ state, dispatch, commit, getters }) => {
      var translations = []
      let currentLanguage =
        state.selected_language || localStorage.getItem('selectedLanguage')
      if (getters.domainBasedBrand) {
        if (getters.all_brand_web_translations) {
          for (var brand_trans of getters.all_brand_web_translations) {
            translations[brand_trans['default']] = brand_trans[currentLanguage]
          }
        }
      } else {
        for (var trans of getters.all_web_translations) {
          translations[trans['en-US']] = trans[currentLanguage]
        }
      }
      commit('SET_TRANSLATIONS', translations)
      // dispatch('setCurrentLanguage', currentLanguage)
    },
    setCurrentLanguage: ({ dispatch, commit, getters }, langCode) => {
      if (getters.currentLanguage != langCode) {
        var lang_record = getters.find_language_by_main_id(langCode)
        if (lang_record) {
          commit('SET_SELECTED_LANG', lang_record.code)
          commit('SET_LANG_DIRECTION', lang_record.direction)
          dispatch('setupTranslations')
          localStorage.setItem('selectedLanguage', langCode)
        }
      }
    },
    setSelectedCountry: async ({ commit }, country) => {
      commit('SET_SELECTED_COUNTRY', country)
      localStorage.setItem('selectedCountry', country)
    },
    determineCurrentLanguage: ({ dispatch, commit, getters }) => {
      //TODO determine language basing on browser request/stored user cookie
      let browserLanguage =
        window.navigator.userLanguage || window.navigator.language || 'en-US'
      let langCode = localStorage.getItem('selectedLanguage')
      if (!langCode) {
        langCode = browserLanguage
      }
      let avail_lang = getters.availableLanguages
      if (avail_lang) {
        if (avail_lang.find(item => item.code == langCode) == undefined) {
          langCode = 'en-US'
        }
      }
      var lang_record = getters.find_language_by_main_id(langCode)
      if (lang_record) {
        commit('SET_SELECTED_LANG', lang_record.code)
        commit('SET_LANG_DIRECTION', lang_record.direction)
        dispatch('setupTranslations')
      }
    },
    getUserCountry: ({ commit }) => {
      const newAxios = axios.create()
      delete newAxios.defaults.headers.Authorization
      newAxios
        .get('https://ipinfo.io', {
          // headers: {
          //   'token': '060b25dd89aaa2'
          // }
        })
        .then(response => {
          commit('SET_USER_LOCATION', response.data)
        })
    },
  },
  getters: {
    _T: (state, getters) => str => {
      if (
        state.translations &&
        typeof state.translations[str] !== 'undefined'
      ) {
        var res = state.translations[str]
        if (res) {
          return res
        }
      }
      utils.process_warning(
        `no ${str} translation exists for ${state.current_language}`,
        false
      )
      return str
    },
    _T_DB: (state, getters) => (db_object, attribute) => {
      if (!db_object) return false
      if (
        db_object['translations_dict'] &&
        db_object['translations_dict'][attribute] &&
        db_object['translations_dict'][attribute][getters.currentLanguage]
      ) {
        return db_object['translations_dict'][attribute][
          getters.currentLanguage
        ]
      }
      //TODO think if we need to log the situation
      return db_object[attribute]
    },
    availableLanguages: (state, getters) => {
      let all_langs = getters.all_goorder_language
      // eslint-disable-next-line no-unused-vars
      let current_brand_languages = getters.currentBrand
        ? getters.currentBrand.website_enabled_languages
        : all_langs.length
        ? all_langs[0].enabled_languages
        : []
      //if (getters.domainBasedBrand) {
      //var brands_langs = current_brand_languages
      return getters.all_languages.filter(item =>
        current_brand_languages.includes(item.code)
      )
      // } else {
      //   if (current_brand_languages) {
      //     var goorder_langs = current_brand_languages
      //     return getters.all_languages.filter(item =>
      //       goorder_langs.includes(item.code)
      //     )
      //   }
      // }
    },
    currentLanguage: state => state.selected_language,
    currentLanguageFullName: (state, getters) => {
      let selected_lang = state.selected_language
        ? getters.find_language_by_main_id(state.selected_language)
        : false
      return selected_lang ? selected_lang.name : 'English'
    },
    availableCountries: (state, getters) => {
      var attr_to_check = 'available_goorder'
      if (getters.domainBasedBrand) attr_to_check = 'website'
      if (getters.domainBasedBrand) {
        var brands_countries = getters.all_stores.reduce(
          (accumulator, item) => {
            if (item[attr_to_check]) {
              accumulator[item.country] = 1
            }
            return accumulator
          },
          {}
        )
        return getters.all_countries.filter(
          item => brands_countries[item.country_code]
        )
      } else {
        let all_langs = getters.all_goorder_language
        if (all_langs.length) {
          var goorder_countries = all_langs[0].enabled_countries
          return getters.all_countries.filter(item =>
            goorder_countries.includes(item.country_code)
          )
        }
      }
    },
    arrowAlignment: state => state.arrow_alignment,
    selectedCountry: (state, getters) => {
      //if there is store selector then choose store city
      if (getters.selectedCheckoutStore) {
        return getters.selectedCheckoutStore.country
      }

      if (
        getters.customer_address &&
        getters.customer_address.delivery_area_id
      ) {
        return getters.customer_address.delivery_area_id.split('|')[2]
      }

      if (state.selected_country) {
        return state.selected_country
      }
      return getters.userLocation ? getters.userLocation.country : undefined
    },
    getArrowAlignment: state => state.arrow_alignment,
    currentCountryFullName: (state, getters) => {
      return getters.find_country_by_main_id(state.current_country).name
    },
    userLocation: state => state.user_location,
  },
}
